import Vue from 'vue'
import {
  PhList,
  PhExport,
  PhShareNetwork,
  PhCaretLeft,
  PhCaretRight,
  PhArrowLeft,
  PhArrowRight,
  PhPlusCircle,
  PhX,
  PhPlus,
  PhFunnelSimple,
  PhDotsThree,
  PhDotsThreeCircle,
  PhArrowsOutSimple,
  PhCaretDown,
  PhCaretUp,
  PhCopySimple,
  PhEyeSlash,
  PhMagnifyingGlass,
  PhEnvelopeSimple,
  PhPaperPlaneTilt,
  PhBellSimple,
  PhCirclesFour,
  PhUsersThree,
  PhSlidersHorizontal,
  PhUserCircle,
  PhChatCircle,
  PhChatCircleDots,
  PhLinkSimple,
  PhBookmarkSimple,
  PhPencilSimpleLine,
  PhTrashSimple,
  PhHeart,
  PhPushPin,
  PhFileImage,
  PhFile,
  PhFolder,
  PhImage,
  PhSortAscending,
  PhEye,
  PhSignOut,
  PhSignIn,
  PhArchiveTray,
  PhPhoneCall,
  PhProhibit,
  PhHouseSimple,
  PhArrowUpRight,
  PhArrowSquareOut,
  PhGlobe,
  PhGlobeSimple,
  PhCheck,
  PhChecks,
  PhCheckCircle,
  PhFileText,
  PhCalendar,
  PhCalendarPlus,
  PhClock,
  PhMapPin,
  PhHeartBreak,
  PhGhost,
  PhStar,
  PhArchive,
  PhDotsThreeVertical,
  PhWarning,
  PhCalendarCheck,
  PhEnvelope,
  PhCrownSimple,
  PhMinusCircle,
  PhCircleNotch,
  PhDownloadSimple,
  PhQrCode,
  PhChartBar,
  PhChatCircleText,
  PhArrowBendUpLeft,
  PhXCircle,
  PhChats,
  PhFilePng,
  PhFilePdf,
  PhFileCss,
  PhFileCsv,
  PhFileDoc,
  PhFileJpg,
  PhFileJs,
  PhFileJsx,
  PhFilePpt,
  PhFileRs,
  PhFileTs,
  PhFileTsx,
  PhFileVue,
  PhFileXls,
  PhFileZip,
  PhFileAudio,
  PhFileVideo,
  PhFileHtml,
  PhCirclesThree,
  PhUserSquare,
  PhThumbsUp,
  PhThumbsDown,
  PhHandWaving,
  PhHandshake,
  PhLightning,
  PhInfo,
  PhScan,
  PhDeviceMobile,
  PhWarningOctagon,
  PhClockCounterClockwise,
  PhTimer,
  PhUsers,
  PhPower
} from 'phosphor-vue'

const icons = {
  PhList,
  PhExport,
  PhShareNetwork,
  PhCaretLeft,
  PhCaretRight,
  PhArrowLeft,
  PhArrowRight,
  PhX,
  PhPlus,
  PhFunnelSimple,
  PhDotsThree,
  PhDotsThreeCircle,
  PhArrowsOutSimple,
  PhCaretDown,
  PhCaretUp,
  PhEyeSlash,
  PhMagnifyingGlass,
  PhEnvelopeSimple,
  PhEnvelope,
  PhPaperPlaneTilt,
  PhBellSimple,
  PhCirclesFour,
  PhUsersThree,
  PhSlidersHorizontal,
  PhUserCircle,
  PhChatCircle,
  PhChatCircleDots,
  PhLinkSimple,
  PhBookmarkSimple,
  PhPencilSimpleLine,
  PhTrashSimple,
  PhHeart,
  PhPushPin,
  PhFileImage,
  PhCopySimple,
  PhFile,
  PhFolder,
  PhImage,
  PhSortAscending,
  PhEye,
  PhSignOut,
  PhSignIn,
  PhArchiveTray,
  PhPhoneCall,
  PhProhibit,
  PhHouseSimple,
  PhArrowUpRight,
  PhArrowSquareOut,
  PhGlobe,
  PhGlobeSimple,
  PhCheck,
  PhChecks,
  PhCheckCircle,
  PhFileText,
  PhCalendar,
  PhCalendarPlus,
  PhPlusCircle,
  PhClock,
  PhMapPin,
  PhHeartBreak,
  PhGhost,
  PhStar,
  PhArchive,
  PhDotsThreeVertical,
  PhWarning,
  PhCalendarCheck,
  PhCrownSimple,
  PhMinusCircle,
  PhCircleNotch,
  PhDownloadSimple,
  PhQrCode,
  PhChartBar,
  PhChatCircleText,
  PhArrowBendUpLeft,
  PhXCircle,
  PhChats,
  PhFilePng,
  PhFilePdf,
  PhFileCss,
  PhFileCsv,
  PhFileDoc,
  PhFileJpg,
  PhFileJs,
  PhFileJsx,
  PhFilePpt,
  PhFileRs,
  PhFileTs,
  PhFileTsx,
  PhFileVue,
  PhFileXls,
  PhFileZip,
  PhFileAudio,
  PhFileVideo,
  PhFileHtml,
  PhCirclesThree,
  PhUserSquare,
  PhThumbsUp,
  PhThumbsDown,
  PhHandWaving,
  PhHandshake,
  PhLightning,
  PhInfo,
  PhScan,
  PhDeviceMobile,
  PhWarningOctagon,
  PhClockCounterClockwise,
  PhTimer,
  PhUsers,
  PhPower
}

for (let i = 0; i < Object.keys(icons).length; i++) {
  const key = Object.keys(icons)[i]
  Vue.component(key, icons[key])
}
